export default {
  "content": "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M8 4l4 2-4 2-2 4-2-4-4-2 4-2 2-4 2 4z\" clip-rule=\"evenodd\" opacity=\".2\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none",
    "viewBox": "0 0 24 24"
  }
};